module YVR.Utilities.Urls  {
	/**
	 * Fetch a hash parameter's value by key
	 * @param {string} key Key to retrieve from the hash
	 * @param {string} [url] Optional URL parameter if not reading off current hash
	 * @returns {string} Parameter's value
	 */
	export function getHashStringParameter(key: string, url?: string): string {
		url = url || window.location.hash.substring(1);  // If no URL passed in then grab location.search off hash
		key = key.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

		const regex = new RegExp(`${key}=([^&#]*)`);
		const results = regex.exec(url);

		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}


	/**
	 * Fetch a query string parameter's value by key
	 * @param {string} key Key to retrieve from the query string
	 * @param {string} [url] Optional URL parameter if not reading off current query string
	 * @returns {string} Parameter's value
	 */
	export function getQueryStringParameter(key: string, url?: string): string {
		url = url || window.location.search;  // If no URL passed in then grab location.search off query string
		key = key.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

		const regex = new RegExp(`[\\?&]${key}=([^&#]*)`);
		const results = regex.exec(url);

		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}
}
